
 <template>
  <div class="dash-board container mt-5 p-4 shadow-sm border-0 bg-white rounded-4">
    <div class="row mb-4">
      <div class="col-12">
        <profile />
      </div>
    </div>

    <div class="row mb-4 overflow-auto pb-2 custom-scrollbar flex-nowrap gx-3 px-3">
      <div class="col-auto">
        <div @click="changeWorkspace(null)" 
             :class="['team-card-mini', !groupId ? 'active-team' : '']">
          <div class="avatar-box"><i class="fas fa-user"></i></div>
          <span class="team-name-text">Personal Stats</span>
        </div>
      </div>
      <div v-for="team in teams" :key="team.id" class="col-auto">
        <div @click="changeWorkspace(team.id)" 
             :class="['team-card-mini', Number(groupId) === team.id ? 'active-team' : '']">
          <div class="avatar-box">{{ team.name.charAt(0).toUpperCase() }}</div>
          <span class="team-name-text">{{ team.name }}</span>
        </div>
      </div>
    </div>

    <div v-if="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Synchronizing data...</p>
    </div>

    <template v-else>
      <div class="row mb-5 text-center g-3">
         
        <div class="col-md-4">
          <div class="stat-card bg-soft-secondary border">
            <div class="icon-box bg-secondary"><i class="fas fa-list-ul"></i></div>
            <h6 class="text-muted fw-bold">TO DO</h6>
            <p class="display-6 fw-bold text-dark">{{ stats.todo }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="stat-card bg-soft-primary border">
            <div class="icon-box bg-primary"><i class="fas fa-spinner fa-spin"></i></div>
            <h6 class="text-primary fw-bold">IN PROGRESS</h6>
            <p class="display-6 fw-bold text-dark">{{ stats.inProgress }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="stat-card bg-soft-success border">
            <div class="icon-box bg-success"><i class="fas fa-check-circle"></i></div>
            <h6 class="text-success fw-bold">DONE</h6>
            <p class="display-6 fw-bold text-dark">{{ stats.done }}</p>
          </div>
        </div>
      </div>
       <div class="row">
        <ai-assistance-card />
       </div>
      <div class="row justify-content-center mt-3">
        <div class="col-md-8 col-lg-6 chart-wrapper p-4 bg-light rounded-4 border">
          <h5 class="text-center mb-4 fw-bold text-secondary">
             {{ groupId ? 'Group Task Distribution' : 'Personal Task Distribution' }}
          </h5>
          <div class="chart-container">
            <canvas ref="tasksChart"></canvas>
          </div>
        </div>
      </div>
    </template>

    <div class="progress-section mb-5 p-4 bg-white rounded-4 border mt-3">
      <div class="d-flex justify-content-between mb-2">
        <span class="fw-bold text-secondary">Completion Rate</span>
        <span class="fw-bold text-primary">{{ completionPercentage }}%</span>
      </div>
      <div class="progress" style="height: 12px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
             role="progressbar" 
             :style="{ width: completionPercentage + '%' }">
        </div>
      </div>
    </div>

    <subscription />
  </div>
</template>

<script>
import Profile from '@/components/Profile.vue';
import { Chart } from 'chart.js/auto';
import { tasksService } from "@/services/tasksService"; 
import { groupsService } from "@/services/groupsService"; 
import Subscription from '@/components/Subscription.vue';
import AiAssistanceCard from '@/components/AiAssistanceCard.vue';
 
 

export default {
  name: "DashBoardView",
  components: { Profile, Subscription ,AiAssistanceCard},
  props: ['groupId'],  

  data() {
    return {
      stats: { done: 0, todo: 0, inProgress: 0 },
      isLoading: false,
      teams: [],
      refreshTimer: null,
      chartInstance: null
    };
  },

  watch: {
   
    groupId: {
      immediate: true,
      handler(newId) {
        this.loadDashboardData(newId);
      }
    }
  },

  mounted() {
    this.fetchTeams();
    
    
    this.refreshTimer = setInterval(() => {
      this.loadDashboardData(this.groupId, true); 
    }, 30000);
  },

  methods: {
    async fetchTeams() {
      try {
        const res = await groupsService.getMyGroups(); 
        this.teams = res || [];
      } catch (err) {
         throw err;
      }
    },

    
    changeWorkspace(id) {
      this.$router.push({ 
        name: 'Dashboard', 
        params: { groupId: id || undefined } 
      });
      this.$store.commit('SET_SELECTED_GROUP',id);
    },
    async loadDashboardData(id = null, silent = false) {
      if (!silent) this.isLoading = true;
      try {
        const allTasks = await tasksService.getAllTasks(id);
        
        let done = 0, todo = 0, inProgress = 0;
        allTasks.forEach((task) => {
          const status = task.status ? task.status.toLowerCase().trim() : '';
          if (status === 'done') done++;
          else if (status === 'to do' || status === 'todo') todo++;
          else if (status === 'in progress') inProgress++;
        });

        this.stats = { done, todo, inProgress };
        
        this.$nextTick(() => {
          this.updateOrCreateChart([done, todo, inProgress]);
        });
      } catch (error) {
        console.error("Dashboard Load Error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    
    updateOrCreateChart(newData) {
  const canvas = this.$refs.tasksChart;
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

   
  const safeData = newData.map(val => val || 0);

  
  if (this.chartInstance) {
    this.chartInstance.destroy();
    this.chartInstance = null;
  }

 
  this.chartInstance = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['Done', 'To Do', 'In Progress'],
      datasets: [{
        data: safeData,
        backgroundColor: ['#198754', '#6c757d', '#0d6efd'],
        hoverOffset: 15,
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '75%',
      plugins: {
        legend: { position: 'bottom', labels: { usePointStyle: true, padding: 20 } }
      }
    }
  });
}
  },

  computed: {
    completionPercentage() {
      const total = this.stats.done + this.stats.todo + this.stats.inProgress;
      return total > 0 ? Math.round((this.stats.done / total) * 100) : 0;
    }
  },

  beforeUnmount() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
    if (this.chartInstance) this.chartInstance.destroy();
  }
}
</script>




<style scoped lang="scss">
 
.team-card-mini {
  background: white; border: 1px solid #dee2e6;
  padding: 10px 15px; border-radius: 15px;
  display: flex; align-items: center; cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;

  &.active-team {
    border-color: #0d6efd; background-color: #eef6ff;
    .avatar-box { background: #0d6efd; color: white; }
    .team-name-text { color: #0d6efd; font-weight: bold; }
  }

  .avatar-box {
    width: 32px; height: 32px; background: #f8f9fa;
    border-radius: 8px; display: flex; align-items: center;
    justify-content: center; margin-right: 10px;
  }
}

.stat-card {
  padding: 25px; border-radius: 20px; transition: transform 0.3s;
  &:hover { transform: translateY(-5px); }
  .icon-box {
    width: 40px; height: 40px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    color: white; margin: 0 auto 10px;
  }
}

.custom-scrollbar::-webkit-scrollbar { height: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #dee2e6; border-radius: 10px; }
</style>

 
 


 
 